import Vue from 'vue'
import Router from 'vue-router'
import RouterConfig from './modules/index' // 引入业务逻辑模块
import CommonRouters from './common'
// import store from '../store'

Vue.use(Router)

// this.$route.query
// this.$route.params
const router = new Router({
  scrollBehavior: () => ({y: 0}),
  routes: RouterConfig.concat(CommonRouters)
})

router.beforeEach((to, from, next) => {
  // store.dispatch('global/setLoading', false)
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

export default router